import { Component, OnInit, Directive } from "@angular/core";
import { ModalController, NavParams } from "@ionic/angular";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,
} from "@angular/forms";
import { AppService } from "src/app/app.service";
import { Global } from "../../../global";
import { Subject } from "rxjs";

@Component({
  selector: "app-datepicker-modal",
  templateUrl: "./equipment-modal.page.html",
  styleUrls: ["./equipment-modal.page.scss"],
})
export class EquipmentModalPage implements OnInit {
  callingFilter: string;
  User_GUID: string;
  Vendor_GUID: string;
  equipmentList: any;
  equipmentSelectedList: any;
  loadingDone: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private formBuilder: FormBuilder,
    private appservice: AppService,
    public globals: Global
  ) {}

  ngOnInit() {
    this.callingFilter = this.navParams.data.paramObject.callingFilter;
    this.User_GUID = this.navParams.data.paramObject.User_GUID;
    this.Vendor_GUID = this.navParams.data.paramObject.Vendor_GUID;

    this.GetEquipmentList();
  }

  async onEquipmentSelect(event: any, equipment: any) {
    await this.modalCtrl.dismiss(equipment);
  }

  GetEquipmentList() {
    var subject = new Subject<any>();

    const formData: FormData = new FormData();

    formData.append("GUID", this.globals.XRSUser.GUID);
    formData.append("Vendor_GUID", this.Vendor_GUID);
    formData.append("isPopup", "true");
    formData.append("search", "");
    formData.append("filter", "AllEquipment");
    formData.append("sort", "Created");
    formData.append("take", "" + 20);
    formData.append("skip", "" + 0);
    formData.append("callingFilter", "" + this.callingFilter);
    formData.append("User_GUID", "" + this.User_GUID);

    this.appservice.GetEquipmentList(formData).subscribe((res) => {
      try {
        this.loadingDone = true;
        this.equipmentList = JSON.parse(res.toString());
      } catch (e) {}
    });

    return subject.asObservable();
  }

  async closeModal() {
    await this.modalCtrl.dismiss(this.equipmentSelectedList);
  }

  async onCloseUpload() {
    await this.modalCtrl.dismiss(this.equipmentSelectedList);
  }

  // public onPagesLoaded(pagecount: PagesLoadedEvent): void {
  //   //this.TotalPages = pagecount.pagesCount;
  // }

  // public onPageRendered(pageRendered: PageRenderedEvent): void {
  //   //this.CurrentPage = pageRendered.pageNumber;
  // }
}
